import React from "react";
import NavbarMobile from "../../components/shared/navbar-mobile";
import NavbarDesktop from "../../components/shared/navbar-desk";

const Header = () => {
  return (
    <>
      <NavbarMobile />
      <NavbarDesktop />
    </>
  );
};

export default Header;
